// @tennis-matches/ui-components/loading-overlay
// SuspenseLoaderToken: rendert null, triggert das globale Loading-Overlay via startLoading/stopLoading.
// Verwendung: <Suspense fallback={<SuspenseLoaderToken />}>...</Suspense>
// Vermeidet doppelte Loader (Inline-Karte + Overlay) und sorgt für einheitliches "App lädt..."-UX.

import { useEffect } from "react";
import { startLoading, stopLoading } from "./loadingOverlay.events.js";

/**
 * @param {{ message?: string, delayMs?: number, minShowMs?: number }} props
 */
export function SuspenseLoaderToken({ message, delayMs = 200, minShowMs = 400 }) {
  useEffect(() => {
    const token = startLoading(message, { delayMs, minShowMs });
    return () => {
      stopLoading(token);
    };
  }, [message, delayMs, minShowMs]);

  return null;
}
